import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { Drawer } from './components/Drawer'
import { queryClient } from './lib/queryClient'
import { AppRouter } from './router'

import './App.css'

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Drawer.Provider>
        <AppRouter />
      </Drawer.Provider>
      <Toaster />
    </QueryClientProvider>
  )
}

export default App
